// The shell sets this marker before Vue starts; browser width alone must never
// opt into the native application's presentation.
export function initializeNativeIOSLayout() {
    const nativeIOS = Boolean(window.__CORECRY_IOS_BUILD__)
    document.documentElement.classList.toggle('corecry-ios-app', nativeIOS)
    return nativeIOS
}
